<template>
  <div id="tab2" class="tab active">
    <!--    <Popup v-if="selectedImage" :image="selectedImage"></Popup>-->
    <isotope
      :list="list"
      id="root_isotope"
      class="isoDefault"
      :options="option"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="item.extra"
        :style="{ 'background-color': item.color }"
      >
        <a @click="selectedImage = item.original">
          <!--          <span class="inner" :style="{'background-color': item.color}">-->
          <!--            <h1>{{ item.title }}</h1>-->
          <!--            <p>{{ item.desc }}</p>-->
          <!--          </span>-->
          <img :src="item.image" />
        </a>
      </div>
    </isotope>
    <hire />
  </div>
</template>

<script>
import isotope from "vueisotope";

export default {
  components: { isotope },
  data() {
    return {
      selectedImage: "",
      list: [
        {
          image: "/img/gallery/sm/13.gif",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#2F2C36",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/12.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FDF6F3",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/11.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#2F2C36",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/7.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FDF6F3",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/8.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#707185",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/9.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#D53F04",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/14.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#EC7D5F",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/2.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#102E60",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/6.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FE8A8B",
          extra: "item-1x",
        },

        {
          image: "/img/gallery/sm/3.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#C1C1C1",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/4.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#FFC476",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/5.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#E3686B",
          extra: "item-1x",
        },
        {
          image: "/img/gallery/sm/1.jpg",
          title: "Jadu",
          desc: "Jadu bhut bada",
          color: "#2e2e2e",
          extra: "item-1x",
        },
      ],
      selected: null,
      option: {
        getSortData: {
          id: "id",
        },
        sortBy: "id",
      },
    };
  },
};
</script>
